import { module as Module } from 'modujs'

export default class extends Module {
  constructor(m) {
    super(m)
  }

  init() {
    this.data = this.el.dataset.slug
  }

  show(args) {
    if (this.data === args) {
      this.el.classList.add('-hover')
    }
  }

  hide(args) {
    if (this.data === args) {
      this.el.classList.remove('-hover')
    }
  }
}
